import React ,{useEffect, useState} from 'react'
import {AiFillEye, AiFillGithub} from "react-icons/ai"

import { AppWrap ,MotionWrap} from '../../wrapper'
import {urlFor, client} from "../../client"
import {motion} from "framer-motion"
import "./Work.scss"

const Work = () => {
  const [ActiveFilter, setActiveFilter] = useState('All')
  const [AnimateCard,setAnimatedCard] = useState({y:0, opacity:1})
  const [Works, setWorks] = useState([])
  const [WorkFilter, setWorkFilter] = useState([])
  
  ////////////////////////////////////////////////
  const handleWorkFilter = (_item) =>{
    setActiveFilter(_item)
    setAnimatedCard([{y:100, opacity:0}])

    setTimeout(() => {
      setAnimatedCard([{y:0, opacity:1}])
      
      if(_item === 'All'){
        setWorkFilter(Works)
      }else{
        setWorkFilter(Works.filter((work)=>(work.tags.includes(_item))))
      }
    
    }, 500);

    
  }
  ////////////////////////////////////////////////
  useEffect(() => {
    client.fetch("*[_type =='works']").then((data)=>{
      setWorkFilter(data)
      setWorks(data)
    })

    
  }, [])
  
  return (
    <>
      <h2 className='head-text'>My <span>Portfolio </span><br/> Section </h2>
      
      <div className='app__work-filter'>
          {['Dapps','Web Apps','CLI Tools','React/Next','All'].map((item,index)=>(
              <div 
                key={item}
                onClick={()=> handleWorkFilter(item)}
                className={`app__work-filter-item app__flex  ${ActiveFilter === item ? 'item-active':''}`}
              > 
                {item}
              </div> 
          ))}
      </div>

      <motion.div
        animate={AnimateCard}
        transition={{duration:0.5 , delayChildren:0.5}}
        className='app__work-portfolio'
      >
          {WorkFilter.map((work,index)=>(
                  <div className='app__work-item app__flex' key={index}>
                          <div className=' app__work-img'>
                                  <img src={urlFor(work.imgUrl)} alt={work.name}/>

                                  <motion.div
                                    whileHover={{opacity:[0,1]}}
                                    transition={{duration:0.25 , staggerChildren:0.5, ease:'easeInOut' }}
                                    className='app__work-hover app__flex'
                                  >
                                         {/* project  link  */}
                                        <a
                                            href={work.projectLink}
                                            target='_blank'
                                            rel='noreferrer' 
                                        >
                                            <motion.div
                                            whileInView={{scale:[0,1]}}
                                                whileHover={{scale:[1,0.9]}}
                                                transition={{duration:0.25  }}
                                                className=' app__flex'
                                            >
                                            <AiFillEye/>
                                          </motion.div>
                                        {/* github link  */}
                                        </a>

                                        <a
                                            href={work.codeLink}
                                            target='_blank'
                                            rel='noreferrer' 
                                        >
                                            <motion.div
                                            whileInView={{scale:[0,1]}}
                                                whileHover={{scale:[1,0.9]}}
                                                transition={{duration:0.25  }}
                                                className=' app__flex'
                                            >
                                            <AiFillGithub/>
                                          </motion.div>

                                        </a>

                                  </motion.div>
                          </div>

                          <div className='app__work-content app__flex'>
                                  <h4 className='bold-text'>{work.title}</h4>
                                  <p className='p-text' style={{marginTop:10}}>{work.description}</p>
                                  <div className='app__work-tag app__flex'>
                                          <p className='p-text'>{work.tags[0]}</p>
                                  </div>
                          </div>
                  </div>

          ))}
      </motion.div>
    
    </>
  )
}

export default AppWrap(
  MotionWrap(Work, 'app__works') ,
  'work',
  'app__primarybg'
  )